import React, { Component } from 'react';
class AutoTransferAppJa extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="mgt-30 faq-container">
            <div className="text-center block-title">
              <h2 className="common-title">TRIAM Auto Transfer</h2>
              <span>version: 1.0.4.1</span>
            </div>
            <div className="content">
              <section className="opening">
                <div className="intro">
                  Auto Transfer機能とは、指定したウォレット内の指定したコインが、設定した数量を超過した
                  際に自動的に他のウォレットへ超過分を転送する機能です。<br />
                  例えば顧客からのコイン支払を受け取るウォレットなどに設定することで、ウォレットの残高の過剰を防ぎ、セキュリティを高めることができます。
                </div>
                <div className="example">
                  <p>例）</p>
                  <ul className="list">
                    <li>
                      <div className="text">
                        <span>① 顧客からのコイン支払を受け取るウォレット」にAuto Transfer機能を設定します</span>
                        <span style={{ marginLeft: '25px' }}>指定コイン：RIA</span>
                        <span style={{ marginLeft: '25px' }}>指定コイン数量：500,000RIA</span>
                        <span style={{ marginLeft: '25px' }}>転送先ウォレット：「顧客支払コイン管理ウォレット」</span>
                      </div>
                    </li>
                    <li>
                      <div className="text">
                        <span>② 顧客から「顧客からのコイン支払を受け取るウォレット」へコイン送信が行われます。</span>
                        <span>「顧客からのコイン支払を受け取るウォレット」内の残高が指定した数量を超えた場合、自動的に過剰分のコインが「顧客支払コイン管理ウォレット」へ転送されます。</span>
                      </div>
                    </li>
                  </ul>
                  <div className="img">
                    <img src="/images/app/auto-transfer-des.png" alt="Auto Transfer Des"/>
                  </div>
                </div>
              </section>
              <hr/>
              <section className="guide guide-1">
                <h3><b>Auto Transfer機能の設定手順</b></h3>
                <ul className="step-guide decimal">
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>① アカウントにログインし、メニュー画面の右下の「Settings」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s1.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>② スクロールし、「Auto Transfer」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s2.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>③「Setup Auto Transfer」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s3.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>1. Wallet & Asset</b></span>
                        <span>④ タイトルやウォレットの選択などを設定します。</span>
                        <span><b>Name</b>…設定するAuto Transferの説明を入力します。</span>
                        <span>※設定後、内容確認、変更等する際に目印になります</span>
                        <span><b>Source wallet</b>…Auto Transfer機能を設定したいウォレットを選択します。</span>
                        <span><b>Min amount</b>…Source walletで保有する残高の上限数量を入力 します。</span>
                        <span><b>Asset</b>…コインの種類を選択します。</span>
                        <span>全ての入力が完了したら「Next」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s4.png" alt="Auto Transfer S3"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>2. Destination & Amount</b></span>
                        <span>⑤Auto Transfer機能が作動した際のコインの転送先ウォレット(Destination Wallet)を選択します。</span>
                        <span><b>･Select destination from your wallets</b></span>
                        <span><b>→</b>同じアカウント内のウォレットの場合はここから選択</span>
                        <span><b>･Enter the destination</b></span>
                        <span><b>→</b>別のアカウント内のウォレットの場合はこちらを選択。直接ウォレットアドレスを入力します。</span>
                        <span>入力内容を再度確認して「Next」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s5.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                    <div className="text highlight">
                      <span>※注意</span>
                      <span>Destination Walletには、コイン受信の際にTagの指定が必要のないウォレットを設定して下さい。もし、Tagの指定が必要な取引所のウォレットアドレス等をDestination Walletに設定した場合、Auto Transferの転送処理自体は実行されますが、受取側で不明な着金となる可能性がありますのでくれぐれもご注意下さい。</span>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>3. Review</b></span>
                        <span>⑥ 次の画面では設定したAuto Transfer機能の流れが図で確認できます。</span>
                        <span>確認して「Next」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s6.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>4. Confirm</b></span>
                        <span>⑦ 最終確認画面が表示されますので、確認して「Confirm」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s7.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑧ OPパスワードを入力し、「Confirm」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s8.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑨ Google二段階認証を入力し、「Confirm」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s9.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>5. Done</b></span>
                        <span>⑩ 設定が完了すると左図になります。</span>
                        <span>メニュー画面へは「Done」をタップして戻ります。</span>
                        <span>これで設定は完了です。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s10.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                </ul>
              </section>
              <section className="guide guide-2">
                <h3 style={{ marginBottom: '10px' }}><b>Auto Transfer機能の設定内容変更及び手順</b></h3>
                <span>Auto Transfer機能の各種設定を変更することができます。</span>
                <ul className="step-guide decimal">
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>① メニュー画面右下の「Settings」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s1.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>② スクロールし、「Auto Transfer」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s2.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>③ 変更したいAuto Transferをタップします。</span>
                        <span>※Nameで設定したAuto Transferを見分けることが出来ます</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s13.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>④ Auto Transferの詳細画面になります。</span>
                        <span>❶ 履歴→コインの転送履歴を見ることができます。</span>
                        <span>❷ 編集→Name、保有コインの残高上限数の変更、転送先ウォレット(Destination Wallet)の変更が行えます。</span>
                        <span>設定内容を変更する場合は❷の編集をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s14.png" alt="Auto Transfer S3" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑤ タイトルやウォレットの変更を行うことができます。</span>
                        <span><b>･Name</b>…設定したAuto Transferの説明を変更できます。</span>
                        <span><b>･Select destination from your wallets</b></span>
                        <span>→同じアカウント内のウォレットの場合はここから選択</span>
                        <span><b>･Enter the destination</b></span>
                        <span>→別のアカウント内のウォレットの場合はこちらに直接ウォレットアドレスを入力します</span>
                        <span><b>･Amount</b>…保有コインの残高上限数の変更ができます。</span>
                        <span>全ての入力が完了したら「Save」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s15.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑥ OPパスワードを入力し、「Confirm」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s8.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑦ Google二段階認証を入力し、「Confirm」をタップします。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s9.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑧ 左図の画面に切り替われば変更は完了です。</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s18.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AutoTransferAppJa;



// WEBPACK FOOTER //
// ./src/containers/auto-transfer-app-ja.jsx